//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The floor plan model.
* 
* @param categoryKey The category key
* @param objectLabel The object label
* @param objectType The object type
* @param seat The seat
* @param cartItemId The order item id
* @param entry The entry
* @param row The row
* @param section The section
*/
@Serializable

data class FloorPlanData (


      /* The category key */
    @SerialName(value = "categoryKey") @Required val categoryKey: kotlin.String,


      /* The object label */
    @SerialName(value = "objectLabel") @Required val objectLabel: kotlin.String,


      /* The object type */
    @SerialName(value = "objectType") @Required val objectType: kotlin.String,


      /* The seat */
    @SerialName(value = "seat") @Required val seat: kotlin.String,


      /* The order item id */
    @SerialName(value = "cartItemId") val cartItemId: kotlin.uuid.Uuid? = null,


      /* The entry */
    @SerialName(value = "entry") val entry: kotlin.String? = null,


      /* The row */
    @SerialName(value = "row") val row: kotlin.String? = null,


      /* The section */
    @SerialName(value = "section") val section: kotlin.String? = null


) {




  }

